<template>
    <div id="navSearch" class="tw-w-full lg:tw-w-auto tw-flex tw-justify-between">
        <button
            class="tw-mr-2 tw-w-full lg:tw-w-[235px] tw-bg-gray-200 tw-text-gray-600 tw-rounded-lg tw-py-2.5 tw-px-3 tw-flex tw-items-center tw-gap-x-2.5 hover:tw-bg-gray-300 hover:tw-text-gray-700 focus-ring-gray tw-text-sm"
            type="button" @click="openSearch">
            <span class="material-symbols-outlined tw-text-lg md:tw-text-base tw-leading-none">search</span>
            <span>{{ __('details.search-title') }}</span>
        </button>
        <span class="tw-h-11 tw-w-px tw-bg-gray-200"></span>

        <button
            class="tw-mx-2 tw-px-3 tw-py-2.5 tw-bg-gray-200 tw-flex tw-items-center tw-gap-x-1.5 tw-rounded-lg tw-text-gray-600 hover:tw-bg-gray-300 hover:tw-text-gray-700 focus-ring-gray"
            type="button" @click.prevent="showLocationModal">
            <i class="material-symbols-outlined tw-leading-none tw-hidden md:tw-inline-block"
                style="font-variation-settings: 'FILL' 1;">{{ locationName == 'Home' || locationName == 'Work' ?
                    'add_home_work' : 'location_on' }}</i>
            <span class="tw-text-sm tw-font-semibold tw-truncate">{{ locationName == 'Home' || locationName == 'Work' ?
                __('details.' + locationName) : locationName }}</span>
            <span
                class="material-symbols-outlined tw-leading-none tw-text-xl tw-hidden md:tw-inline-block">expand_more</span>
        </button>
        <!-- SEARCH DROPDOWN (NEW)  -->
        <transition name="dropdown">
            <div v-click-outside="closeSearch" v-if="isDropdownOpen"
                class="tw-w-full tw-h-screen lg:tw-h-[520px] tw-fixed tw-top-[68px] lg:tw-top-[77px] tw-left-0 tw-py-8 tw-px-8 tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-start tw-bg-white tw-shadow-2xl tw-z-20 tw-overflow-y-scroll"
                ref="searchContainer">
                <div class="tw-w-full lg:tw-w-2/3 tw-mx-auto">
                    <div class="tw-relative tw-bg-gray-50 tw-rounded-full tw-w-full tw-mb-2">
                        <span
                            class="material-symbols-outlined tw-absolute tw-text-xl tw-leading-none tw-top-1/2 tw-left-4 -tw-translate-y-1/2">search</span>
                        <input ref="searchInput"
                            class="tw-w-full tw-py-3 tw-px-4 tw-pl-11 tw-bg-transparent tw-border-0 placeholder:tw-text-gray-500 focus:tw-outline-none focus:tw-ring-0"
                            v-model="query" :placeholder="`${__('details.search-title')}...`" @input.prevent="search"
                            @keyup.enter="submitQuery" @blur.prevent="exit" @keyup.esc="exit" />
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-y-4">
                        <div v-if="loading"
                            class="tw-px-[18px] tw-pt-3 tw-text-gray-600 tw-font-medium tw-text-sm tw-animate-pulse">
                            {{ __('details.loading') }}...
                        </div>
                        <div v-if="(perks.length || sponsoredPerks.length) && !loading" class="tw-flex tw-flex-col">
                            <p v-if="sponsoredPerks.length"
                                class="tw-text-sm tw-font-semibold tw-text-gray-500 tw-mb-1">{{ __('details.sponsored')
                                }}</p>

                            <button v-for="perk of sponsoredPerks" :key="perk.id" type="button"
                                class="tw-flex tw-items-center tw-gap-x-2 tw-p-2 tw-rounded-full hover:tw-bg-gray-50 focus:tw-bg-gray-50 focus:tw-ring focus:tw-ring-gray-300/50"
                                @click="selectOption(perk)">
                                <span
                                    class="material-symbols-outlined tw-text-gray-400 tw-leading-none tw-text-xl tw-font-bold">arrow_right_alt</span>
                                <span class="tw-text-gray-900 tw-text-sm tw-flex-grow tw-text-left tw-whitespace-nowrap"
                                    v-html="perk.title"></span>
                                <span
                                    class="tw-ml-auto tw-text-sm tw-text-gray-400 tw-w-1/2 lg:tw-max-w-[490px] tw-text-right tw-truncate"
                                    v-html="perk.offer"></span>
                            </button>
                            <p v-if="sponsoredPerks.length && perks.length"
                                class="tw-text-sm tw-font-semibold tw-text-gray-500 tw-mb-1">{{ __('details.more') }}</p>
                            <button v-for="perk of perks" :key="perk.id" type="button"
                                class="tw-flex tw-items-center tw-gap-x-2 tw-p-2 tw-rounded-full hover:tw-bg-gray-50"
                                @click="selectOption(perk)">
                                <span
                                    class="material-symbols-outlined tw-text-gray-400 tw-leading-none tw-text-xl tw-font-bold">arrow_right_alt</span>
                                <span class="tw-text-gray-900 tw-text-sm tw-flex-grow tw-text-left tw-whitespace-nowrap"
                                    v-html="perk.title"></span>
                                <span
                                    class="tw-ml-auto tw-text-sm tw-text-gray-400 tw-w-1/2 lg:tw-max-w-[490px] tw-truncate tw-text-right"
                                    v-html="perk.offer"></span>
                            </button>

                            <button type="button"
                                class="tw-text-primary-700 tw-mt-1 tw-text-xs tw-flex tw-items-center tw-cursor-pointer tw-gap-x-1 tw-p-2 hover:tw-bg-gray-50 tw-self-start tw-rounded-full focus:tw-bg-gray-50 focus:tw-ring focus:tw-ring-primary-300/50"
                                @click="submitQuery">
                                <span>{{ __('details.view_all_text') }} ({{ lastTotalHits }}) </span>
                                <span class="material-icons-outlined tw-text-xl tw-leading-none">chevron_right</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="false"
                    class="tw-hidden lg:tw-block tw-mt-12 tw-bg-gray-50 tw-w-96 tw-py-8 tw-px-5 tw-rounded-lg">
                    <p class="tw-text-sm tw-font-semibold tw-text-primary-600 tw-mb-3">Black Friday deals</p>
                    <div class="tw-flex tw-flex-col tw-gap-y-1">
                        <div class="tw-p-3 tw-flex tw-gap-x-6">
                            <div class="tw-border tw-border-gray-300 tw-rounded tw-w-[50px] tw-h-[50px] tw-shrink-0">
                                <img class="tw-object-scale-down" src="https://via.placeholder.com/50" alt="perk logo">
                            </div>
                            <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between">
                                <p class="tw-text-sm tw-font-semibold tw-text-gray-700">Apple</p>
                                <span
                                    class="tw-border tw-border-gray-200 tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-gray-700">New</span>
                                <p class="tw-w-full tw-text-gray-500 tw-text-sm tw-mt-1 tw-line-clamp-1	">Apple and your
                                    company have included you in a special program. You qualify for preferred pricing on
                                    select Apple products and accessories.*</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <UserLocationModal ref="locationModal" :primary-location="primaryLocation" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UserLocationModal from "components/workperks/UserLocationModal.vue";
import { createArgumentsFromObj, navigateToUrl } from 'lib/Utilities';
import { TrackingAction } from "lib/workperks/models/Analytics";
import analyticsService from 'lib/workperks/services/AnalyticsService';
import createSearchServiceWithOptions from 'lib/workperks/services/createSearchServiceWithOptions';
import User from 'lib/User';
import { sortMap } from 'lib/workperks/services/SearchService';
import clickOutside from 'lib/workperks/directives/clickOutside';
import ESSponsoredSearchService from 'lib/workperks/services/ESSponsoredSearchService';
import ESSponsoredKeywordsService from 'lib/workperks/services/ESSponsoredKeywordsService';
import { SPONSORED_RESULT_FALSE, SPONSORED_RESULT_TRUE } from 'lib/workperks/common/constants';
import { throttle } from 'lodash';

export default defineComponent({
    name: 'perk-search',
    data() {
        return {
            perks: [],
            max: 7,
            sponsoredPerks: [],
            searchService: null,
            sponsoredSearchService: null,
            loading: false,
            lastTotalHits: 0,
            query: '',
            filters: {
                sort: 0,
                distance: null,
                showNewOnly: false,
                showExpiringOnly: false,
                giftCardOnly: false,
                redemptionFilter: [1, 2, 4],
            },
            lastSelectedIndex: -1,
            focusResult: null,
            primaryLocation: null,
            locale: window.l.locale,
            locationName: '',
            source: null,
            isDropdownOpen: false,
            sponsoredKeywordService: null,
            sponsoredKeywords: [],
        }
    },
    created() {
        this.primaryLocation = User.getCurrent().primaryLocation;
        this.filters.distance = this.primaryLocation.range;
        this.initSearchService();
    },
    mounted() {
        this.locationName = this.primaryLocation?.label ||
            this.primaryLocation?.province ||
            this.primaryLocation?.country;

        this.source = this.primaryLocation.country === 'US' ? 'Access-US' : 'Venngo-CA';
    },
    methods: {
        initSearchService() {
            this.searchService = createSearchServiceWithOptions({
                user: User.getCurrent().data,
                location: this.primaryLocation,
                language: this.locale,
            });

            this.sponsoredSearchService = new ESSponsoredSearchService({
                user: User.getCurrent().data,
                location: this.primaryLocation,
                language: this.locale,
            });

            this.sponsoredKeywordService = new ESSponsoredKeywordsService();
        },
        search: throttle(async function () {
            if (!this.query?.trim()) {
                this.loading = false;
                this.perks = [];
                this.sponsoredPerks = [];
                this.lastTotalHits = 0;
                return;
            }

            try {
                const queryTrimmed = this.query?.trim() || '';
                this.loading = true;

                // GET KEYWORDS
                this.sponsoredKeywords = await this.sponsoredKeywordService.search(queryTrimmed) || [];

                // SPONSORED RESULTS
                const sponsoredData = await this.sponsoredSearchService
                    .setDistance(this.filters.distance)
                    .setSort(sortMap[this.filters.sort].value)
                    .setOffset(0)
                    .search(queryTrimmed) || [];

                this.sponsoredPerks = sponsoredData.slice(0, this.max);
                this.addTrackingFieldsToPerks(this.sponsoredPerks, queryTrimmed, this.sponsoredKeywords, SPONSORED_RESULT_TRUE);
                this.trackPerkSearchResults(this.sponsoredPerks);

                // ORGANIC RESULTS
                const data = await this.searchService
                    .setShowNew(this.filters.showNewOnly)
                    .setDistance(this.filters.distance)
                    .setShowExpiringSoon(this.filters.showExpiringOnly)
                    .setGiftCardOnly(this.filters.giftCardOnly)
                    // .setRedemptionType(this.redemptionFilter)
                    .setSort(sortMap[this.filters.sort].value)
                    .setOffset(0)
                    .search(queryTrimmed) || [];

                this.perks = data.slice(0, this.max - this.sponsoredPerks.length);
                this.lastTotalHits = this.searchService._lastTotalHits + this.sponsoredSearchService._lastTotalHits;
                if (this.perksDidLoad) {
                    this.perksDidLoad(this.perks);
                }
                this.addTrackingFieldsToPerks(this.perks, queryTrimmed, this.sponsoredKeywords, SPONSORED_RESULT_FALSE);
                this.trackPerkSearchResults(this.perks);
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
            }
        }, 500),
        addTrackingFieldsToPerks(perks, keyword, sponsoredKeywords, sponsoredResult) {
            perks.forEach(function (perk, index) {
                perk.keyword = keyword;
                perk.position = index + 1;
                perk.sponsored_keyword = Number(sponsoredKeywords.some(item => item.name === keyword));
                perk.sponsored_result = sponsoredResult;
            });
        },
        trackPerkSearchResults(perks = []) {
            perks.forEach(perk => analyticsService.setTemplateId(null).trackPerkSearch(perk, TrackingAction.View));
        },
        trackPerkSearchResultClick(perk) {
            analyticsService.setTemplateId(null).trackPerkSearch(perk, TrackingAction.Click);
            analyticsService.setTemplateId(null).trackSearchQuery(this.query, this.source, 'user', this.primaryLocation.range);
        },
        // Navigates to the page of the perk selected from the dropdown
        selectOption(perk) {
            const trackingPayload = {
                "source": perk.source ?? "es",
                "keyword": perk.keyword ?? "",
                "position": perk.position ?? "",
                "sponsored_keyword": perk.sponsored_keyword ?? "",
                "sponsored_result": perk.sponsored_result ?? "",
            };

            this.trackPerkSearchResultClick(perk);
            const payload = createArgumentsFromObj(trackingPayload);
            navigateToUrl(`/offer/${perk.id}?${payload}`);
        },
        exit() {
            if (this.perk) {
                if (!this.perk.id) {
                    this.perks = [];
                    this.query = '';
                } else {
                    this.query = this.perk.title;
                }
            }
        },
        // FIXME: Should be using the route instead of a static URL.
        submitQuery() {
            analyticsService.setTemplateId(null).trackSearchQuery(this.query, this.source, 'user', this.primaryLocation.range);
            navigateToUrl(`/search?query=${encodeURIComponent(this.query)}`);
        },
        showLocationModal() {
            this.$refs.locationModal.showLocationModal();
        },
        openSearch() {
            this.isDropdownOpen = true;
            document.querySelector('body').style.overflowY = 'hidden';
            document.addEventListener('keydown', this.handleKeyDown);
            this.$nextTick(() => {
                this.$refs.searchInput?.focus();
            });
        },
        closeSearch() {
            this.isDropdownOpen = false;
            document.removeEventListener('keydown', this.handleKeyDown);
            document.querySelector('body').removeAttribute('style');
            this.perks = [];
            this.sponsoredPerks = [];
            this.query = '';
        },
        handleKeyDown(e) {
            if (e.key === 'Escape') {
                return this.closeSearch();
            }

            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            const focusableElements = 'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])';

            const focusableContent = this.$refs.searchContainer.querySelectorAll(focusableElements);
            const firstFocusableElement = focusableContent[0];
            const lastFocusableElement = focusableContent[focusableContent.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else if (document.activeElement === lastFocusableElement) {
                firstFocusableElement.focus();
                e.preventDefault();
            }
        },
    },
    components: {
        UserLocationModal,
    },
    directives: {
        'click-outside': clickOutside,
    }
});
</script>

<style>
.dropdown-enter-active,
.dropdown-leave-active {
    transition: all 0.5s;
}

.dropdown-enter,
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
</style>